import { Outlet, useLocation } from 'react-router-dom';
import ReceivePayments from './ReceivePayments';
import { ReceivePaymentsHubProvider } from './ReceivePaymentsHubContext';

const OVERLAY_PATTERN = /^\/receive-payments\/(invoice\/|payment\/)/;

const ReceivePaymentsLayout = () => {
  const { pathname } = useLocation();
  const overlayOpen = OVERLAY_PATTERN.test(pathname);

  return (
    <ReceivePaymentsHubProvider>
      <div
        className={overlayOpen ? 'pointer-events-none select-none opacity-60' : undefined}
        aria-hidden={overlayOpen}
      >
        <ReceivePayments />
      </div>
      <Outlet />
    </ReceivePaymentsHubProvider>
  );
};

export default ReceivePaymentsLayout;
